import { Center, Heading, Text, VStack } from '@chakra-ui/react';

import {
  Link,
  PageContainer,
  PageContent,
  pageContentDefaultProps,
} from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { RegisterNetworkCard } from './RegisterNetworkCard';

export const IntroductionSection = () => {
  const { content } = usePageTextContent<RegisterNetworkPageContent>();

  const { title, subtitle, description, phoneNumberLabel, phoneNumber } =
    content.introduction;

  return (
    <PageContainer bgGradient="linear(to-r, blue.600, blue.800)" isFullHeight>
      <PageContent
        align="center"
        justify="center"
        direction={['column', 'column', 'row']}
        px={0}
      >
        <VStack
          align={['center', 'center', 'flex-start']}
          spacing="2rem"
          w="full"
          minW={['full', 'full', '45rem']}
          px={pageContentDefaultProps.px}
        >
          <VStack align="flex-start" spacing="1.25rem">
            <Heading color="white" fontSize="1.875rem">
              {title}
            </Heading>

            <Heading
              color="network.secondary"
              fontSize="2.5rem"
              whiteSpace="pre-line"
            >
              {subtitle}
            </Heading>
          </VStack>

          <Text
            color="white"
            fontSize="1.125rem"
            maxW="44rem"
            whiteSpace="pre-line"
          >
            {description}
          </Text>

          <Link
            href={`tel:${phoneNumber}`}
            color="network.secondary"
            _hover={{ color: 'network.secondary' }}
            isExternal
          >
            {phoneNumberLabel}
          </Link>
        </VStack>

        <Center w="full" my={['2rem', '2rem', 0]}>
          <RegisterNetworkCard />
        </Center>
      </PageContent>
    </PageContainer>
  );
};
